import { isPresent } from '../../../utils/isPresent';
import { React, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Masonry from "react-smart-masonry";
import "../../PublicShare/Shared/Shared.scss";
import "../../../shades/Bucket.scss";
import "./PublicBucket.scss";
import TopBarPublic from "../TopbarPublic/TopbarPublic";
import "@fortawesome/react-fontawesome";
import "@fortawesome/free-solid-svg-icons";
import "@fortawesome/free-solid-svg-icons";
import "@headlessui/react";
import SingleCard from "../../../shades/cards/singleCard";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "react-router-dom";















import { toastify } from "../../Toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../../../shades/cards/shareCard";

import "../../../shades/cards/includes/MoveModal";
const breakpoints = { mobile: 0, tablet: 900, desktop: 1200 };

function PublicBucket() {
  useRef();
  const navigate = useNavigate();
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  useState(false);
  // const [userList, setUserList] = useState([]);
  const [lastList, setLastList] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [subBucket, setSubBucket] = useState([]);
  const [cardList, setCardList] = useState([]);
  const [, setIsLoading] = useState(true);
  useState(false);
  const [bucketCreated, ] = useState(false);
  useState(false);
  const [cardCreated, setCardCreated] = useState(false);
  useState("Add");
  const [, setSelectedItems] = useState([]);
  useState(false);
  useState(false);
  // const [isOpen] = useOutletContext();
  const [buckets, setBuckets] = useState([]);
  useState("");
  const [clickedCardId, setClickedCardId] = useState(null);
  const [, setTotalCards] = useState(0);
  const [, setBucketSharePopup] = useState(false);
  const [, setShareBucketId] = useState("");
  const [, setAppTheme] = useState("")
  useState(false);
  const bucketId = useParams();

  useEffect(() => {
    const handleStorageChange = () => {
      const theme = localStorage.getItem("theme");
      setAppTheme(theme);
    };

    window.addEventListener('storage', handleStorageChange);

    // Force a re-render when localStorage changes
    setAppTheme(localStorage.getItem("theme"));

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);





  const handleSharePop = (id) => {
    setShareBucketId(id);
    setBucketSharePopup(true);
  };
  const filterDropDown = [
    { name: "Created Date", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
    // { name: 'Manual', href: '#' },
  ];

  let cardFilterv = "";
  if (!localStorage.getItem("cardFilter")) {
    localStorage.setItem("cardFilter", "Created_Date");
    cardFilterv = "Created_Date";
  } else {
    cardFilterv = localStorage.getItem("cardFilter");
  }
  const [cardFilterDefault, ] = useState(cardFilterv);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem("token");
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}buckets/user-buckets`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);
  useEffect(() => {
    // This request belongs to the current route/filter; ignore responses after cleanup.
    let active = true;

    // api url
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setIsLoadings(true);
      await axios
        .post(
          `${process.env.REACT_APP_API}buckets/public-shared-bucket`,
          { filterValue: cardFilterDefault, bucketId: bucketId.id, page: currPage, limit: 8 },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function (response) {
          if (!active) return;
          setIsLoading(false);
          if (!response.data.data.cardsList.length) {
            setLastList(true);
            setIsLoadings(false);
            return;
          }
          setPrevPage(currPage);
          // setUserList([...userList, ...response.data.data]);
          setCardList(current => [...current, ...response.data.data.cardsList]);
          setTotalCards(response.data.data.totalCards);
          setIsLoadings(false);
          setSubBucket(response.data.data);
          // setCardList(response.data.data);
          // setBucketList(response.data.data.bucketList);
          // setTotalBuckets(response.data.data.total);
          // reorder(response.data.data.slice(0,response.data.data.length),4);
        })
        .catch(function (error) {
          if (!active) return;
          console.error(error);
          toastify("error", error.response.data.message);
          setTimeout(() => {
            navigate(`/expiry`);
          }, 1000);
        });
        if (!active) return;
    };


    const getBrowserId = () => {
      // Implement your logic to generate or retrieve a unique browser ID
      // For example, you might use a combination of user agent and some randomization
      const userAgent = navigator.userAgent;
      const randomPart = Math.random().toString(36).substring(2, 15);
      const browserId = `${userAgent}_${randomPart}`;

      return browserId;
    };

    const StarredCard = async () => {
      const token = localStorage.getItem("token");
      try {
        await axios.patch(
          `${process.env.REACT_APP_API}cards/updateSharedCard-engagements`,
          { cardId: bucketId.id, views: 1 },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!active) return;
      } catch (error) {
        console.error(error);
      }
    };

    const browserId = getBrowserId();

    if (
      !localStorage.getItem("browserId") &&
      !localStorage.getItem("sharedCardId")
    ) {
      localStorage.setItem("browserId", browserId);
      localStorage.setItem("sharedBucketId", bucketId.id);
      // const token = localStorage.getItem("token");
      StarredCard();
    } else {
      const sharedBucketId = localStorage.getItem("sharedBucketId");
      if (bucketId.id !== sharedBucketId) {
        localStorage.setItem("sharedBucketId", bucketId.id);
        StarredCard();
      }
    }

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;
      if (
        parseInt(scrollTop) + parseInt(clientHeight) ===
        parseInt(scrollHeight)
      ) {
        setCurrPage(currPage + 1);
      }
    };

    if (!lastList && prevPage !== currPage) {
      fetchData();
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      active = false;
      window.removeEventListener("scroll", handleScroll);
    };
  }, [bucketCreated, cardCreated, currPage, lastList, prevPage, bucketId.id, cardFilterDefault, navigate]);
  const handleCardClick = (cardId) => {
    setClickedCardId(cardId);
  };
  useEffect(() => {
  }, [clickedCardId]);




  // const [filtersText, setFiltersText] = useState(filterDropDown[0].name);
  useState(
    cardFilterv === "Created_Date"
      ? filterDropDown[0].name
      : cardFilterv === "Descending_Order"
        ? filterDropDown[3].name
        : cardFilterv === "Ascending_Order"
          ? filterDropDown[2].name
          : cardFilterv === "Recent_Activity"
            ? filterDropDown[1].name
            : ""
  );

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };














  const handleCardClickRequest = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.patch(
        `${process.env.REACT_APP_API}cards/updateSharedCard-engagements`,
        { cardId: bucketId.id, clicks: 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleSignup = async () => {
    window.open("/signup", "_blank");
  };








  function cardUpdate() {
    // setBucketCreated(true);
    setLastList(false);
    setCurrPage(1);
    setPrevPage(0);
    setCardList([]);
    setCardCreated(!cardCreated);
  }







  return (
    <div>
      <TopBarPublic />
      <div className="publicshare-section" onClick={handleCardClickRequest}>
        <div className="flex publicspace-content">
          <div className="publicdesc-content">
            {subBucket?.sharedItems
              ? subBucket?.sharedItems[0]?.sharedBy?.firstName
              : ""}{" "}
            {subBucket?.sharedItems
              ? subBucket?.sharedItems[0]?.sharedBy?.lastName
              : ""} shared this bucket using Zimzee.com
          </div>
          <div className="buttonpublic-content">
            <button
              style={{
                filter: "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
              }}
              onClick={handleSignup}
              className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white"
            >
              <span className="savebutton-context">Sign Up</span>
            </button>
          </div>
        </div>
        <div className="publictag-content">
          <div className="subBuckets-whole listingCards">
            {/* Single Card */}
            <div className="mansorydesktop-section">
              <Masonry
                breakpoints={breakpoints}
                columns={{ mobile: 1, tablet: 3, desktop: 4 }}
                gap={{ mobile: 20, tablet: 15, desktop: 15 }}
                style={{ display: "flex" }}
              >
                {/* <div 
        onScroll={onScroll}
        ref={listInnerRef}
        // style={{ height: "100vh", overflowY: "auto" }}
      > */}
                {cardList?.map((card) => {
                  const sharedWithObjects = card?.shared
                    ? card.shared
                      .filter(shares => isPresent(shares.sharedWith))
                      .map(shares => shares.sharedWith)
                    : [];
                  return (
                    <SingleCard
                      key={card._id}
                      handleSharePop={handleSharePop}
                      starred={card.starred}
                      buckets={buckets}
                      cardUpdate={cardUpdate}
                      cardId={card._id}
                      cardType={card.cardType}
                      sharedBy={[]}
                      sharedUsers={sharedWithObjects}
                      sharedLength={card.shared.length}
                      title={card.title}
                      content={card.content}
                      note={card.note}
                      tags={card.tags}
                      postDetail={card.postDetail ? card.postDetail : ""}
                      updated={card.updatedAt}
                      handleCheckboxChange={handleCheckboxChange}
                      handleCardClick={handleCardClick}
                      PublicBucket={true}
                    />
                  );
                })}
                {/* </div> */}
              </Masonry>
            </div>
            {isLoadings && (
              <Masonry
                breakpoints={breakpoints}
                columns={{ mobile: 2, tablet: 3, desktop: 4 }}
                gap={{ mobile: 20, tablet: 15, desktop: 15 }}
              >
                <div
                  className="cardHolder rounded-[14px] overflow-hidden break-inside"
                  style={{ height: "330px" }}
                >
                  <div className="cardheight-content">
                    <div className="flex justify-between w-full px-3 pt-3">
                      <div className="inputCheck">
                        <input type="checkbox" />
                      </div>
                      <div className="flex">
                        <Skeleton />
                      </div>
                    </div>
                    <div className="cardHeader flex items-center pb-1 px-3">
                      <div className="logo w-[30px] rounded">
                        <Skeleton />
                      </div>
                      <div className="Cardtitle w-3/4 pl-3">
                        <Skeleton />
                      </div>
                      <div className="iconsRight flex items-center">
                        <Skeleton />
                      </div>
                    </div>
                    <p></p>
                    <div className="cardContent cardListContent w-full">
                      <Skeleton />
                    </div>
                  </div>
                  <div className="px-3">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                </div>
                <div
                  className="cardHolder rounded-[14px] overflow-hidden break-inside"
                  style={{ height: "330px" }}
                >
                  <div className="cardheight-content">
                    <div className="flex justify-between w-full px-3 pt-3">
                      <div className="inputCheck">
                        <input type="checkbox" />
                      </div>
                      <div className="flex">
                        <Skeleton />
                      </div>
                    </div>
                    <div className="cardHeader flex items-center pb-1 px-3">
                      <div className="logo w-[30px] rounded">
                        <Skeleton />
                      </div>
                      <div className="Cardtitle w-3/4 pl-3">
                        <Skeleton />
                      </div>
                      <div className="iconsRight flex items-center">
                        <Skeleton />
                      </div>
                    </div>
                    <p></p>
                    <div className="cardContent cardListContent w-full">
                      <Skeleton />
                    </div>
                  </div>
                  <div className="px-3">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                </div>
                <div
                  className="cardHolder rounded-[14px] overflow-hidden break-inside"
                  style={{ height: "330px" }}
                >
                  <div className="cardheight-content">
                    <div className="flex justify-between w-full px-3 pt-3">
                      <div className="inputCheck">
                        <input type="checkbox" />
                      </div>
                      <div className="flex">
                        <Skeleton />
                      </div>
                    </div>
                    <div className="cardHeader flex items-center pb-1 px-3">
                      <div className="logo w-[30px] rounded">
                        <Skeleton />
                      </div>
                      <div className="Cardtitle w-3/4 pl-3">
                        <Skeleton />
                      </div>
                      <div className="iconsRight flex items-center">
                        <Skeleton />
                      </div>
                    </div>
                    <p></p>
                    <div className="cardContent cardListContent w-full">
                      <Skeleton />
                    </div>
                  </div>
                  <div className="px-3">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                </div>
                <div
                  className="cardHolder rounded-[14px] overflow-hidden break-inside"
                  style={{ height: "330px" }}
                >
                  <div className="cardheight-content">
                    <div className="flex justify-between w-full px-3 pt-3">
                      <div className="inputCheck">
                        <input type="checkbox" />
                      </div>
                      <div className="flex">
                        <Skeleton />
                      </div>
                    </div>
                    <div className="cardHeader flex items-center pb-1 px-3">
                      <div className="logo w-[30px] rounded">
                        <Skeleton />
                      </div>
                      <div className="Cardtitle w-3/4 pl-3">
                        <Skeleton />
                      </div>
                      <div className="iconsRight flex items-center">
                        <Skeleton />
                      </div>
                    </div>
                    <p></p>
                    <div className="cardContent cardListContent w-full">
                      <Skeleton />
                    </div>
                  </div>
                  <div className="px-3">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                  <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                    <Skeleton />
                  </div>
                </div>
              </Masonry>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
export default PublicBucket;
